"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATOR_CATEGORIES = exports.ValidatorSubCategory = exports.ValidatorCategory = void 0;
var ValidatorCategory;

(function (ValidatorCategory) {
  ValidatorCategory["ApiServer"] = "ApiServer";
  ValidatorCategory["RBAC"] = "RBAC";
  ValidatorCategory["Security"] = "Security";
  ValidatorCategory["Container"] = "Container";
  ValidatorCategory["Storage"] = "Storage";
  ValidatorCategory["Compute"] = "Compute";
  ValidatorCategory["Networking"] = "Networking";
  ValidatorCategory["Configuration"] = "Configuration";
  ValidatorCategory["Misc"] = "Misc";
  ValidatorCategory["Traefik"] = "Traefik";
})(ValidatorCategory = exports.ValidatorCategory || (exports.ValidatorCategory = {}));

var ValidatorSubCategory;

(function (ValidatorSubCategory) {
  ValidatorSubCategory["VolumeMount"] = "VolumeMount";
  ValidatorSubCategory["EnvironmentVariables"] = "EnvironmentVariables";
  ValidatorSubCategory["Controller"] = "Controller";
  ValidatorSubCategory["Scale"] = "Scale";
  ValidatorSubCategory["Status"] = "Status";
  ValidatorSubCategory["Misc"] = "Misc";
})(ValidatorSubCategory = exports.ValidatorSubCategory || (exports.ValidatorSubCategory = {}));

exports.VALIDATOR_CATEGORIES = [{
  id: ValidatorCategory.Container,
  name: 'Container'
}, {
  id: ValidatorCategory.Compute,
  name: 'Compute'
}, {
  id: ValidatorCategory.Configuration,
  name: 'Configuration'
}, {
  id: ValidatorCategory.Networking,
  name: 'Networking'
}, {
  id: ValidatorCategory.Storage,
  name: 'Storage'
}, {
  id: ValidatorCategory.RBAC,
  name: 'RBAC'
}, {
  id: ValidatorCategory.Security,
  name: 'Security'
}, {
  id: ValidatorCategory.ApiServer,
  name: 'Kubernetes API Server'
}, {
  id: ValidatorCategory.Misc,
  name: 'Miscellaneous'
}, {
  id: ValidatorCategory.Traefik,
  name: 'Traefik Proxy'
}];